export const ANDROID_PACKAGE = process.env.REACT_APP_ANDROID_PACKAGE;
export const APP_STORE_URL = 'http://goo.gl/88kSr';
export const PLAY_STORE_URL = 'market://details?id=com.Classting';
